/*
 * Vertical spacing is page-scoped, since the pages carrying this band do not share one rhythm. The
 * defaults suit a 72px section whose preceding block already provides the band's top padding. A
 * page on another rhythm overrides these two custom properties rather than fighting the rules below
 * on specificity.
 */
.cta {
  padding: var(--cta-section-padding, 0 0 72px);
}

.cta__band {
  background: var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW */
  border: 3px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  border-radius: 22px;
  padding: var(--cta-band-padding, 56px 40px);
  text-align: center;
  box-shadow: var(--plume-shadow-cta, 1px 2px 14px 0 rgba(89, 84, 78, 0.12));
}

.cta__title {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 900;
  /* HACK: fluid display size — candidate future DS heading scale */
  font-size: clamp(32px, 4.4vw, 58px);
  line-height: 1.02;
  letter-spacing: -0.02em;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  margin: 0 0 14px;
}

.cta__lede {
  font-size: 18px; /* COPY_L */
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  opacity: 0.82;
  margin: 0 0 30px;
}

.cta__actions {
  display: flex;
  gap: 14px;
  justify-content: center;
  flex-wrap: wrap;
}
